import { TFunction } from 'i18next';
import { TravelStatus } from 'models/travelStatus';

export type TagsColor = 'red' | 'yellow' | 'green' | 'gray';
export type TagsIcon = 'clock' | 'x' | 'check' | 'exclamation';

export interface StatusTag {
  text: string;
  icon: TagsIcon;
  color: TagsColor;
}

export function statusTranslation(status: TravelStatus | string | undefined, t: TFunction): string {
  switch (status) {
    case TravelStatus.Approved:
      return t('dashboard.card.approvedTag');
    case TravelStatus.Confirmed:
      return t('dashboard.card.confirmedTag');
    case TravelStatus.Paid:
      return t('dashboard.card.paidTag');
    case TravelStatus.Expired:
      return t('dashboard.card.expiredTag');
    case TravelStatus.Reproved:
      return t('dashboard.card.reprovedTag');
    case TravelStatus.ErrorAtSending:
      return t('dashboard.card.errorAtSendingTag');
    case TravelStatus.PaymentFailure:
      return t('dashboard.card.paymentFailureTag');
    default:
      return status || '';
  }
}
